// extracted by mini-css-extract-plugin
export default {"modal":"del_modal__Uato1","img":"del_img__s5GYM","btnDiv":"del_btnDiv__wrdkB","btn":"del_btn__7ZXqA"};